import type { ReactNode } from 'react';

export const symbol_line_end_arrow: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M486-229q-15 10-30.5 1T440-255v-195H110q-13 0-21.5-8.5T80-480q0-13 8.5-21.5T110-510h330v-195q0-18 15.5-27t30.5 1l354 226q14 9 14 25t-14 25L486-229Zm14-80 268-171-268-171v342Zm0-171Z"
		/>
	</svg>
);
